<template>
  <div class="tami-card-form">
    <div class="tami-card-list">
      <Card
          :fields="fields"
          :labels="formData"
          :isCardNumberMasked="isCardNumberMasked"
          :randomBackgrounds="randomBackgrounds"
          :backgroundImage="backgroundImage"
      />
    </div>
    <div class="tami-card-form__inner">
      <div class="tami-card-input">
        <label for="cardNumber" class="tami-card-input__label">{{ $t('cardForm.cardNumber') }}</label>
        <input
            type="tel"
            :id="fields.cardNumber"
            @input="changeNumber"
            @focus="focusCardNumber"
            @blur="blurCardNumber"
            class="tami-card-input__input"
            :value="formData.cardNumber"
            :maxlength="cardNumberMaxLength"
            data-card-field
            autocomplete="off"
        />
        <button
            type="button"
            class="tami-card-input__eye"
            :class="{ '-active' : !isCardNumberMasked }"
            title="Show/Hide card number"
            tabindex="-1"
            :disabled="formData.cardNumber === ''"
            @click="toggleMask"
        ></button>
      </div>
      <div class="tami-card-input">
        <label for="cardName" class="tami-card-input__label">{{ $t('cardForm.cardName') }}</label>
        <input
            type="text"
            :id="fields.cardName"
            v-letter-only
            @input="changeName"
            class="tami-card-input__input"
            :value="formData.cardName"
            data-card-field
            autocomplete="off"
        />
      </div>
      <div class="tami-card-form__row">
        <div class="tami-card-form__col">
          <div class="tami-card-form__group">
            <label for="cardMonth" class="tami-card-input__label">{{ $t('cardForm.expirationDate') }}</label>
            <select
                class="tami-card-input__input -select"
                :id="fields.cardMonth"
                v-model="formData.cardMonth"
                @change="changeMonth"
                data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.month') }}</option>
              <option
                  v-bind:value="n < 10 ? '0' + n : n"
                  v-for="n in 12"
                  v-bind:disabled="n < minCardMonth"
                  v-bind:key="n"
              >{{ generateMonthValue(n) }}
              </option>
            </select>
            <select
                class="tami-card-input__input -select"
                :id="fields.cardYear"
                v-model="formData.cardYear"
                @change="changeYear"
                data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.year') }}</option>
              <option
                  v-bind:value="$index + minCardYear"
                  v-for="(n, $index) in 12"
                  v-bind:key="n"
              >{{ $index + minCardYear }}
              </option>
            </select>
          </div>
        </div>
        <div class="tami-card-form__col -cvv">
          <div class="tami-card-input">
            <label for="cardCvv" class="tami-card-input__label">{{ $t('cardForm.CVV') }}</label>
            <input
                type="tel"
                class="tami-card-input__input"
                v-number-only
                :id="fields.cardCvv"
                maxlength="4"
                :value="formData.cardCvv"
                @input="changeCvv"
                data-card-field
                autocomplete="off"
            />
          </div>
        </div>
      </div>
      <div class="tami-card-form--installment-lines" v-if="rates.length">

        <table border="0" cellpadding="0" cellspacing="0" width="100%">
          <thead>
          <tr>
            <th align="center"></th>
            <th align="left">{{ $t('cardForm.installmentTableNumber') }}</th>
            <th align="right">{{ $t('cardForm.installmentTableTotal') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in rates" :key="item.id">
            <th align="center">
              <input type="radio"
                     :name="installment"
                     :checked="item.id === formData.installment"
                     @input="changeInstallment"
                     :value="item.id" :id="`tami-installment-${item.id}`"/>
            </th>
            <td align="left">
              <label :for="`tami-installment-${item.id}`">{{ item.label }}</label>
            </td>
            <td align="right">
              <label :for="`tami-installment-${item.id}`">{{ currencySymbol }}{{
                  (orderTotal / ((100 - item.rate) / 100)).toFixed(2)
                }}</label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card'

export default {
  name: 'CardForm',
  directives: {
    'number-only': {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, '')
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true
          }
          event.preventDefault()
        }

        el.addEventListener('keypress', checkValue)
      }
    },
    'letter-only': {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault()
          }
          return true
        }

        el.addEventListener('keypress', checkValue)
      }
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          cardName: '',
          cardNumber: (typeof window['tamiPaymentForm'] === 'object' && typeof window['tamiPaymentForm'].cardNumber === 'string' ? window['tamiPaymentForm'].cardNumber : ''),
          cardNumberNotMask: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: '',
          installment: '1'
        }
      }
    },
    backgroundImage: [String, Object],
    randomBackgrounds: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Card
  },
  data() {
    return {
      fields: {
        cardNumber: 'v-card-number',
        cardName: 'v-card-name',
        cardMonth: 'v-card-month',
        cardYear: 'v-card-year',
        cardCvv: 'v-card-cvv',
        installment: '1'
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19,
      binNumber: '',
      installment: 1,
      rates: {},
      orderTotal: typeof window['tamiCheckoutFields'].paymentAmount === 'string' ? parseFloat(window['tamiCheckoutFields'].paymentAmount) : 0,
      currencySymbol: typeof window['tamiCheckoutFields'].currencySymbol === 'string' ? window['tamiCheckoutFields'].currencySymbol : '₺'
    }
  },
  computed: {
    minCardMonth() {
      if (this.formData.cardYear === this.minCardYear) return new Date().getMonth() + 1
      return 1
    }
  },
  watch: {
    cardYear() {
      if (this.formData.cardMonth < this.minCardMonth) {
        this.formData.cardMonth = ''
      }
    }
  },
  mounted() {
    this.maskCardNumber()
    if (typeof window['tamiPaymentForm'].cardNumber === 'string' && window['tamiPaymentForm'].cardNumber) {
      let backupNumber = window['tamiPaymentForm'].cardNumber
      let backupInstallment = null
      if (typeof window['tamiPaymentForm'].installment === 'number' || typeof window['tamiPaymentForm'].installment === 'string') {
        backupInstallment = window['tamiPaymentForm'].installment
      }
      window['tamiInstallmentBackup'] = backupInstallment
      this.changeNumber({
        inputType: '',
        target: {
          value: ''
        }
      })
      this.changeNumber({
        inputType: '',
        target: {
          value: backupNumber
        }
      })
    }
  },
  methods: {
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n
    },
    changeName(e) {
      this.formData.cardName = e.target.value
      if (typeof window['tamiPaymentForm'] === 'object') {
        window['tamiPaymentForm'].cardHolder = this.formData.cardName
      }
      this.$emit('input-card-name', this.formData.cardName)
    },
    changeInstallment(e) {
      this.formData.installment = e.target.value
      if (typeof window['tamiPaymentForm'] === 'object') {
        window['tamiPaymentForm'].installment = this.formData.installment
      }
      this.$emit('input-installment', this.formData.installment)
    },
    changeNumber(e) {
      this.formData.cardNumber = e.target.value
      let value = this.formData.cardNumber.replace(/\D/g, '')
      // american express, 15 digits
      if ((/^3[47]\d{0,13}$/).test(value)) {
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 17
      } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 16
      } else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
        this.cardNumberMaxLength = 19
      }

      if (typeof window['tamiPaymentForm'] === 'object') {
        window['tamiPaymentForm'].cardNumber = this.formData.cardNumber
      }

      let previousBin = this.binNumber
      if (value.length >= 6 && parseInt(value.substr(0, 6)) !== parseInt(previousBin)) {
        this.binNumber = value.substr(0, 6)
        this.binChanged()
      } else {
        if (value.length === 0) {
          this.binNumber = ''
          this.binChanged()
        }
        if (!this.binNumber && value.length >= 6) {
          this.binChanged()
        }
      }

      // eslint-disable-next-line eqeqeq
      if (e.inputType == 'deleteContentBackward') {
        let lastChar = this.formData.cardNumber.substring(this.formData.cardNumber.length, this.formData.cardNumber.length - 1)
        // eslint-disable-next-line eqeqeq
        if (lastChar == ' ') {
          this.formData.cardNumber = this.formData.cardNumber.substring(0, this.formData.cardNumber.length - 1)
        }
      }
      this.$emit('input-card-number', this.formData.cardNumber)
    },
    async binChanged() {
      let self = this
      this.installment = 0
      let url = ''
      if (typeof window['tamiCheckoutFields'] === 'object' && typeof window['tamiCheckoutFields'].installmentUrl === 'string' && (this.binNumber).length >= 6) {
        url = window['tamiCheckoutFields'].installmentUrl
        if (url.indexOf('?') > -1) {
          url += '&'
        } else {
          url += '?'
        }
        url += 'bin=' + this.binNumber + '&amount=' + this.orderTotal
        await fetch(url, {method: 'GET'}).then(r => r.json()).then(r => {
          let rates = r.rates
          if (!this.binNumber) {
            rates = {}
          }

          if (typeof window['tamiInstallmentBackup'] === 'string') {
            this.changeInstallment({
              target: {
                name: 'installment',
                value: window['tamiInstallmentBackup']
              }
            })
            window['tamiInstallmentBackup'] = undefined
          } else {
            this.changeInstallment({
              target: {
                name: 'installment',
                value: '1'
              }
            })
          }

          this.rates = Object.keys(rates).map(function (value, index) {
            let rate = rates[value]
            let installmentLabel = self.$t('cardForm.installmentTableLabel')
            let advanceLabel = self.$t('cardForm.installmentTableLabelAdvance')
            return {
              id: value,
              label: value > 1 ? installmentLabel.replaceAll('%d', value) : advanceLabel,
              rate: rate
            }
          })
        })
      }
    },
    changeMonth() {
      if (typeof window['tamiPaymentForm'] === 'object') {
        window['tamiPaymentForm'].cardMonth = this.formData.cardMonth
      }
      this.$emit('input-card-month', this.formData.cardMonth)
    },
    changeYear() {
      if (typeof window['tamiPaymentForm'] === 'object') {
        window['tamiPaymentForm'].cardYear = this.formData.cardYear
      }
      this.$emit('input-card-year', this.formData.cardYear)
    },
    changeCvv(e) {
      this.formData.cardCvv = e.target.value
      if (typeof window['tamiPaymentForm'] === 'object') {
        window['tamiPaymentForm'].cardCvv = this.formData.cardCvv
      }
      this.$emit('input-card-cvv', this.formData.cardCvv)
    },
    invaildCard() {
      let number = this.formData.cardNumberNotMask.replace(/ /g, '')
      var sum = 0
      for (var i = 0; i < number.length; i++) {
        var intVal = parseInt(number.substr(i, 1))
        if (i % 2 === 0) {
          intVal *= 2
          if (intVal > 9) {
            intVal = 1 + (intVal % 10)
          }
        }
        sum += intVal
      }
      if (sum % 10 !== 0) {
        alert(this.$t('cardForm.invalidCardNumber'))
      }
    },
    blurCardNumber() {
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      }
    },
    maskCardNumber() {
      this.formData.cardNumberNotMask = this.formData.cardNumber
      this.mainCardNumber = this.formData.cardNumber
      let arr = this.formData.cardNumber.split('')
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== '') {
          arr[index] = '*'
        }
      })
      this.formData.cardNumber = arr.join('')
    },
    unMaskCardNumber() {
      this.formData.cardNumber = this.mainCardNumber
    },
    focusCardNumber() {
      this.unMaskCardNumber()
    },
    toggleMask() {
      this.isCardNumberMasked = !this.isCardNumberMasked
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      } else {
        this.unMaskCardNumber()
      }
    }
  }
}
</script>
